module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ysbz@2x.dceeb222.png";